import React, { createRef } from 'react';
import { classNames, Constants, formatMiles } from '../../../utils';
import { ChevronRightIcon, PaymentCashIcon, PaymentFastIcon, PaymentMobileIcon, PaymentMonthlyIcon, PaymentSlowIcon, PaymentTransferIcon, PaymentZelleIcon } from '../../../assets/icons';
import { connect } from 'react-redux';
import { GeneralService } from '../../../services';

const PAYMENT_TYPE = {
  MONTHLY: 1,
  ANNUAL: 2,
};

class Payment extends React.Component {

  state = {
    form: {
      type: PAYMENT_TYPE.MONTHLY,
      amountToPay: 0,
    },
    request: null,
    paymentMethods: [],
  }

  cartButtonRef = createRef();
  goBack = createRef();

  componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    const request = this.props.request?.purchase;
    if (!request) this.props.history.replace('/');

    this.setState({
      form: {
        ...this.state.form,
        amountToPay: request?.total,
      },
      request,
    });

    this.getPaymentMethods();
  }

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

  getPaymentMethods = async () => {
    try {
      const paymentMethods = await GeneralService.getPaymentMethods();
      this.setState({ paymentMethods });

    } catch (error) {
      console.log(error)
    }
  }

  change = (value,target) => {
    this.setState({
      form: {
        ...this.state.form,
        [target]: value,
      },
    });
  }

  goTo = (route) => {
    this.props.history.push(route);
  }

  render() {

    const { form } = this.state;

    return (
      <div className="w-full sm:w-[30rem] mx-auto flex flex-col mt-8 lg:mt-0">
        {/* <Text style={styles.description}>Selecciona el monto a pagar</Text> */}

        <div className="w-full mt-4 mb-8 flex justify-center relative">
          <div
            className={classNames(
              'rounded-lg flex flex-1 justify-center items-center p-2',
              form.type === PAYMENT_TYPE.MONTHLY ? 'bg-black' : 'bg-gray5'
            )}
          >
            <div className="flex-1 flex justify-center">
              <div className="w-8 h-8 rounded-full flex justify-center items-center bg-black mr-2 absolute left-2">
                <img src={PaymentMonthlyIcon} className="w-5 h-5 object-contain" alt="" />
              </div>
              <p className={classNames('text-2xl font-bold text-center', form.type === PAYMENT_TYPE.MONTHLY ? 'text-white' : 'text-darkBlue')}>
                { formatMiles(this.state.form.amountToPay).replace(' ','') }
              </p>
            </div>
            {/* <div className="flex-1" /> */}
          </div>
        </div>

        {/* {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.ADDRESS) && (
          <PaymentMethod
            label="Domiciliación"
            icon={PaymentAddressIcon}
            color="bg-blue2"
            onClick={() => this.goTo('ClientPaymentAddress')}
          />
        )} */}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.TRANSFER_BNC) && (
          <PaymentMethod
            label="Débito Inmediato"
            icon={PaymentMobileIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/debito-inmediato')}
            // isInstant
          />
        )}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.TRANSFER) && (
          <PaymentMethod
            label="Pago Móvil Directo"
            icon={PaymentMobileIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/pago-movil/directo')}
            // isInstant
          />
        )}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.MOBILE) && (
          <PaymentMethod
            label="Pago Móvil En Banco"
            icon={PaymentMobileIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/pago-movil/banco')}
            // isInstant
          />
        )}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.ZELLE) && (
          <PaymentMethod
            label="Zelle"
            icon={PaymentZelleIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/zelle')}
            // isInstant
          />
        )}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.TRANSFER_MANUAL) && (
          <PaymentMethod
            label="Transferencia"
            icon={PaymentTransferIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/transferencia')}
          />
        )}

        {this.state.paymentMethods.some(x => x.id === Constants.PAYMENT.METHOD.CASH_USD) && (
          <PaymentMethod
            label="Depósito"
            icon={PaymentCashIcon}
            color="bg-darkBlue"
            onClick={() => this.goTo('/pagar/deposito')}
          />
        )}
      </div>
    );
  }
}

const PaymentMethod = ({ icon, color, label, onClick, isInstant }) => (
  <button
    className="flex justify-between items-center bg-white rounded-lg border border-gray6 p-2 mb-4"
    onClick={onClick}
  >
    <div className="flex items-center gap-2">
      <div className={classNames('w-12 h-12 flex justify-center items-center rounded-md', color)}>
        <img src={icon} className="w-8 h-8 object-contain" alt="" />
      </div>
      <div className="flex flex-1 flex-col justify-center text-left">
        <p className="text-md font-semibold text-text text-wrap">
          { label }
        </p>
        {/* <div className="flex items-center gap-1">
          <p className='text-sm text-[#999999] font-semibold'>
            { isInstant ? 'Inmediata' : 'Notificando' }
          </p>
          <img
            src={isInstant ? PaymentFastIcon : PaymentSlowIcon}
            className="w-4 h-4 object-contain mr-2"
            alt=""
          />
        </div> */}
      </div>
    </div>
    <img src={ChevronRightIcon} className="w-4 h-4 object-contain" alt="" />
  </button>
);

export default connect(state => ({
  request: state.request,
}))(Payment);
